import Datagent                     from 'datagent';
import {respondData, requestHandle} from '../utils';
import Fecha                        from '../utils/type/Fecha';
import {defaults}                   from 'datagent/src/utils';

const {filter, format, getField, awaitTo} = Datagent.Hooks;

export const DateFormat = Fecha.format('YYYY-MM-DD HH:mm:ss');
export const DateParse  = Fecha.parse('YYYY-MM-DD HH:mm:ss');

const name  = 'reportData';
const Model = Datagent.Model({
    name,
    fields : {
        'id'              : {type: Number, default: null},            //公司数据id
        'secondTargetNum' : {type: String, default: ''},  //二级指标编码
        'secondTargetName': {type: String, default: ''}, //二级指标名称
        'targetUnit'      : {type: String, default: ''},       //年报数据id
        'targetRule'      : {type: String, default: '0'},       //是否能改变人工打分，0可以改，其他不能
        'firstTargetName' : {type: String, default: ''}, //一级指标名称
        'firstTargetNum'  : {type: String, default: ''},  // 一级指标编号
        'score'           : {type: Number, default: ''},           // 得分
        'value'           : {type: String, default: ''},           // 数值
        'abbreviation'    : {type: String, default: ''},    // 公司简称
        'stockCode'       : {type: String, default: ''},       // 股票代码
        'year'            : {type: Number, default: ''},            // 年份
        'inputSource'     : { type:val=>val===''?3:Number(val), default: 3 },
        'moreRemark'      : {type: String, default: ''},            // 补充说明
    },
    methods: {
        fetch(params, opts){
            const { origin } = defaults(opts);
            const { type, ...query } = params;
            if(typeof type === 'undefined') throw new Error('The type params must be have! use "year" or "social"')
            return this.remote(origin).get(`${type}Report/data/list`, query);
        },
        save(params, opts){
            const { origin } = defaults(opts);
            const { type, ...query } = params;
            if(typeof params.id === 'undefined') throw new Error(`报告数据不支持新建！`)
            if(typeof type === 'undefined') throw new Error('The type params must be have! use "year" or "social"')
            return this.remote(origin).post(`${type}Report/data/`, query);
        },
        previousEdit(params, opts){
          const { origin } = defaults(opts);
          const { type, ...query } = params;
          if(typeof params.id === 'undefined') throw new Error(`报告数据不支持新建！`)
          if(typeof type === 'undefined') throw new Error('The type params must be have! use "year" or "social"')
          return this.remote(origin).post(`${type}Report/data/previousEdit`, query)
        }
    },
    hooks  : {
        ...Datagent.mapSendHook([format()]),
        fetch              : {after: [respondData(), requestHandle(), getField('data', format())]},
        find               : {after: [respondData(), requestHandle(), format()]}
    }
});

Model.ModelName   = name;
Model.validation  = () => {
    return {
        secondTargetNum: [
            { type: 'string', message: '请选择指标', trigger: 'change'}
        ],
        value: [
            { type: 'string', message: '请输入报告值', trigger: 'change'},
        ],
        score: [
            { type: 'number', message: '请输入数字', trigger: 'change', validator: (rule, value)=>{
              if(value === '') return true;
              if(typeof value === 'number' || !Number.isNaN(Number(value))) return true;
              return false
            }}
        ],
    }
};
export default Model;
